module.exports = __webpack_public_path__ + "img/rise.a96e3595.png";